// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width:380px){.page-wrapper-x[data-v-ee875dfe]{padding-left:1rem;padding-right:1rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
